export interface TextAreaProps {
    value?: string;
    name?: string;
    placeholder?: string;
    rows?: number;
    cols?: number;
    onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
}

const TextArea = ({ name, placeholder, rows = 6, cols = 30, value, onChange }: TextAreaProps) => {
    return (
        <div className="flex flex-col pt-4">
            <div className="flex relative">
                <textarea
                    value={value}
                    name={name}
                    cols={cols}
                    rows={rows}
                    placeholder={placeholder}
                    onChange={onChange}
                    className="flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                />
            </div>
        </div>
    );
};

export default TextArea;
